export default __webpack_public_path__ + "static/branch01-5f440eda53b3cd719cd812703f47f5f3.jpg";